(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const bar = document.querySelector('[data-announcement-bar]');
  const dismissBtn = document.querySelector('[data-dismiss-announcement]');

  if (bar && sessionStorage.getItem('announcement-dismissed')) {
    bar.hidden = true;
  }

  if (dismissBtn && bar) {
    dismissBtn.addEventListener('click', () => {
      bar.hidden = true;
      sessionStorage.setItem('announcement-dismissed', 'true');
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  const params = new URLSearchParams(window.location.search);
  const orderParam = params.get('order');
  if (orderParam) {
    const orderInput = document.getElementById('contact-order');
    if (orderInput && !orderInput.value) {
      orderInput.value = orderParam;
      orderInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
    const subjectInput = document.getElementById('contact-subject');
    if (subjectInput && !subjectInput.value) {
      subjectInput.value = 'Help with order ' + orderParam;
      subjectInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  const section = document.querySelector('.customer-addresses');
  if (section) {
    const toggleNewBtn = section.querySelector('[data-toggle-new-address]');
    const newForm = section.querySelector('[data-new-address-form]');
    const cancelNewBtn = section.querySelector('[data-cancel-new-address]');

    if (toggleNewBtn && newForm) {
      toggleNewBtn.addEventListener('click', () => {
        newForm.hidden = !newForm.hidden;
        toggleNewBtn.hidden = !toggleNewBtn.hidden;
      });
    }

    if (cancelNewBtn && newForm && toggleNewBtn) {
      cancelNewBtn.addEventListener('click', () => {
        newForm.hidden = true;
        toggleNewBtn.hidden = false;
      });
    }

    section.querySelectorAll('[data-edit-address]').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.editAddress;
        const display = section.querySelector(`[data-address-display="${id}"]`);
        const editForm = section.querySelector(`[data-edit-form="${id}"]`);
        if (display) display.hidden = true;
        if (editForm) editForm.hidden = false;
      });
    });

    section.querySelectorAll('[data-cancel-edit]').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = btn.dataset.cancelEdit;
        const display = section.querySelector(`[data-address-display="${id}"]`);
        const editForm = section.querySelector(`[data-edit-form="${id}"]`);
        if (display) display.hidden = false;
        if (editForm) editForm.hidden = true;
      });
    });

    section.querySelectorAll('[data-confirm-message]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        if (!confirm(btn.dataset.confirmMessage)) {
          e.preventDefault();
        }
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login"]) return;
  try {
    
  (function () {
    const root = document.currentScript ? document.currentScript.parentElement : document;
    const loginForm = document.querySelector('[data-login-form]');
    const recoverForm = document.querySelector('[data-recover-form]');
    const toggleRecover = document.querySelector('[data-toggle-recover]');
    const toggleLogin = document.querySelector('[data-toggle-login]');

    if (toggleRecover && loginForm && recoverForm) {
      toggleRecover.addEventListener('click', () => {
        loginForm.hidden = true;
        recoverForm.hidden = false;
      });
    }

    if (toggleLogin && loginForm && recoverForm) {
      toggleLogin.addEventListener('click', () => {
        recoverForm.hidden = true;
        loginForm.hidden = false;
      });
    }

    if (window.location.hash === '#recover') {
      if (loginForm) loginForm.hidden = true;
      if (recoverForm) recoverForm.hidden = false;
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const header = document.querySelector('[data-header]');
  const toggle = header?.querySelector('[data-menu-toggle]');
  const mobileNav = header?.querySelector('[data-mobile-nav]');
  const menuIcon = header?.querySelector('[data-menu-icon]');
  const closeIcon = header?.querySelector('[data-close-icon]');

  if (toggle && mobileNav) {
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      mobileNav.hidden = isOpen;
      menuIcon.hidden = !isOpen;
      closeIcon.hidden = isOpen;
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const section = document.querySelector('[data-product-recommendations]');
  if (section) {
    const url = section.dataset.url;
    if (url) {
      fetch(url)
        .then(response => response.text())
        .then(text => {
          const html = new DOMParser().parseFromString(text, 'text/html');
          const recommendations = html.querySelector('[data-product-recommendations]');
          if (recommendations && recommendations.innerHTML.trim().length) {
            section.innerHTML = recommendations.innerHTML;
          }
        })
        .catch(e => console.error('Recommendations error:', e));
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const gallery = document.querySelector('.product__gallery');
  const form = document.querySelector('[data-product-form]');
  const productJsonEl = document.querySelector('[data-product-json]');

  function switchMedia(mediaId) {
    if (!gallery || !mediaId) return;
    const thumbnails = gallery.querySelectorAll('[data-thumbnail]');
    const slides = gallery.querySelectorAll('[data-slide]');

    const targetThumb = gallery.querySelector(`[data-media-id="${mediaId}"]`);
    const targetSlide = gallery.querySelector(`.product__media-slide[data-media-id="${mediaId}"]`);

    if (targetSlide) {
      thumbnails.forEach(t => t.classList.remove('product__thumbnail--active'));
      slides.forEach(s => s.classList.remove('product__media-slide--active'));
      if (targetThumb) targetThumb.classList.add('product__thumbnail--active');
      targetSlide.classList.add('product__media-slide--active');
    }
  }

  if (gallery) {
    const thumbnails = gallery.querySelectorAll('[data-thumbnail]');
    const slides = gallery.querySelectorAll('[data-slide]');
    const totalSlides = slides.length;

    function goToSlide(index) {
      thumbnails.forEach(t => t.classList.remove('product__thumbnail--active'));
      slides.forEach(s => s.classList.remove('product__media-slide--active'));
      thumbnails[index].classList.add('product__thumbnail--active');
      slides[index].classList.add('product__media-slide--active');
    }

    function getActiveIndex() {
      const active = gallery.querySelector('.product__media-slide--active');
      return active ? parseInt(active.dataset.slide, 10) : 0;
    }

    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', () => {
        goToSlide(parseInt(thumb.dataset.thumbnail, 10));
      });
    });

    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        const current = getActiveIndex();
        goToSlide(current > 0 ? current - 1 : totalSlides - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        const current = getActiveIndex();
        goToSlide(current < totalSlides - 1 ? current + 1 : 0);
      });
    }
  }

  const mobileCarousel = document.querySelector('[data-product-carousel]');
  if (mobileCarousel) {
    const dotsContainer = document.querySelector('[data-product-dots]');
    const dots = dotsContainer ? dotsContainer.querySelectorAll('.product__carousel-dot') : [];
    const carouselPrev = document.querySelector('[data-product-carousel-prev]');
    const carouselNext = document.querySelector('[data-product-carousel-next]');

    mobileCarousel.addEventListener('scroll', () => {
      const scrollLeft = mobileCarousel.scrollLeft;
      const slideWidth = mobileCarousel.offsetWidth;
      const activeIndex = Math.round(scrollLeft / slideWidth);

      dots.forEach((dot, i) => {
        dot.classList.toggle('product__carousel-dot--active', i === activeIndex);
      });
    });

    if (carouselPrev) {
      carouselPrev.addEventListener('click', () => {
        mobileCarousel.scrollBy({ left: -mobileCarousel.offsetWidth, behavior: 'smooth' });
      });
    }

    if (carouselNext) {
      carouselNext.addEventListener('click', () => {
        mobileCarousel.scrollBy({ left: mobileCarousel.offsetWidth, behavior: 'smooth' });
      });
    }
  }

  const desktopImage = document.querySelector('.product__main-image--desktop');
  if (desktopImage) {
    desktopImage.addEventListener('mousemove', (e) => {
      const slide = desktopImage.querySelector('.product__media-slide--active');
      if (!slide) return;
      const img = slide.querySelector('img');
      if (!img) return;
      const rect = desktopImage.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(2)';
    });

    desktopImage.addEventListener('mouseleave', () => {
      const slide = desktopImage.querySelector('.product__media-slide--active');
      if (!slide) return;
      const img = slide.querySelector('img');
      if (img) {
        img.style.transform = '';
        img.style.transformOrigin = '';
      }
    });
  }

  if (form && productJsonEl) {
    const variants = JSON.parse(productJsonEl.textContent);
    const optionInputs = form.querySelectorAll('[data-option-input]');
    const variantIdInput = form.querySelector('[data-variant-id]');
    const addBtn = form.querySelector('.product__add-to-bag');

    optionInputs.forEach(input => {
      input.addEventListener('change', () => {
        const selectedOptions = [];
        form.querySelectorAll('[data-option-input]:checked').forEach(checked => {
          selectedOptions.push(checked.value);
        });

        const matchedVariant = variants.find(v => {
          return selectedOptions.every((val, i) => v.options[i] === val);
        });

        if (matchedVariant) {
          variantIdInput.value = matchedVariant.id;

          const notifyForm = document.querySelector('[data-notify-form]');
          const notifyBody = document.querySelector('[data-notify-body]');

          if (addBtn) {
            addBtn.disabled = !matchedVariant.available;
            addBtn.textContent = matchedVariant.available
              ? addBtn.dataset.addText || 'ADD TO BAG'
              : addBtn.dataset.soldText || 'SOLD OUT';

            if (notifyForm) {
              addBtn.hidden = !matchedVariant.available;
              notifyForm.hidden = matchedVariant.available;
            }
          }

          if (notifyBody && matchedVariant.title) {
            notifyBody.value = matchedVariant.title + ' — ' + window.location.href;
          }

          if (matchedVariant.featured_media) {
            switchMedia(matchedVariant.featured_media.id);
          } else if (matchedVariant.featured_image) {
            switchMedia(matchedVariant.featured_image.id);
          }

          const url = new URL(window.location);
          url.searchParams.set('variant', matchedVariant.id);
          window.history.replaceState({}, '', url);
        }
      });
    });
  }

  // Save / wishlist toggle (writes to localStorage.nevelson_saved)
  (function () {
    const STORAGE_KEY = 'nevelson_saved';
    const btn = document.querySelector('[data-product-save]');
    if (!btn) return;
    const handle = btn.getAttribute('data-handle');
    if (!handle) return;

    const read = () => {
      try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        const parsed = raw ? JSON.parse(raw) : [];
        return Array.isArray(parsed) ? parsed : [];
      } catch (_) {
        return [];
      }
    };
    const write = (list) => {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      } catch (_) {}
    };
    const sync = () => {
      const list = read();
      btn.setAttribute('aria-pressed', list.includes(handle) ? 'true' : 'false');
    };

    sync();
    btn.addEventListener('click', () => {
      const list = read();
      const idx = list.indexOf(handle);
      if (idx >= 0) list.splice(idx, 1);
      else list.push(handle);
      write(list);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"]) return;
  try {
    
  const STORAGE_KEY = 'nevelson-recently-viewed';
  const MAX_ITEMS = 10;
  const DISPLAY_LIMIT = 4;

  function getRecentlyViewed() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveProduct(product) {
    let items = getRecentlyViewed();
    items = items.filter(item => item.handle !== product.handle);
    items.unshift(product);
    if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  const productEl = document.querySelector('[data-product-json]');
  const productMeta = document.querySelector('.product');
  if (productMeta && window.location.pathname.includes('/products/')) {
    const titleEl = document.querySelector('.product__title');
    const priceEl = document.querySelector('.product__price');
    const imgEl = document.querySelector('.product__media-slide--active img');

    if (titleEl) {
      const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
      if (handle) {
        saveProduct({
          handle: handle,
          title: titleEl.textContent.trim(),
          url: window.location.pathname,
          image: imgEl ? imgEl.src : '',
          price: priceEl ? priceEl.textContent.trim() : ''
        });
      }
    }
  }

  const section = document.querySelector('[data-recently-viewed]');
  const grid = document.querySelector('[data-recently-viewed-grid]');

  if (section && grid) {
    const items = getRecentlyViewed();
    const currentHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    const filtered = items.filter(item => item.handle !== currentHandle).slice(0, DISPLAY_LIMIT);

    if (filtered.length > 0) {
      filtered.forEach(item => {
        const card = document.createElement('a');
        card.href = item.url;
        card.className = 'product-card';
        card.innerHTML =
          '<div class="product-card__media">' +
            (item.image ? '<img class="product-card__image" src="' + item.image + '" alt="' + item.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="product-card__info">' +
            '<h3 class="product-card__title">' + item.title + '</h3>' +
            '<p class="product-card__price">' + item.price + '</p>' +
          '</div>';
        grid.appendChild(card);
      });
      section.hidden = false;
    }
  }

  } catch(e) { console.error(e); }
})();
})();
